<script>
  export default {
    name: 'layout-assinatura-embed'
  }
</script>

<template>
  <div id="page-wrapper" class="gray-bg assinatura-embed-wrapper">
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-sm-12">
        <h2>{{ $root.tituloDaPagina }}</h2>
      </div>
    </div>

    <div class="wrapper-content animated fadeIn">
      <router-view></router-view>
    </div>
  </div>
</template>

<style>
  #page-wrapper.assinatura-embed-wrapper {
    margin: 0;
    padding: 0;
    min-height: 100vh;
  }

  .assinatura-embed-wrapper .wrapper-content {
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutAssinaturaEmbed.vue